// src/components/contexts/EditorContext.js
import React, { createContext, useContext, useState } from 'react';

// Create a context for the Quill editor
const EditorContext = createContext();

// Provider component
export function EditorProvider({ children }) {
  // State to hold the editor instance
  const [editorInstance, setEditorInstance] = useState(null);
  
  // Function to set the editor instance
  const setEditor = (editor) => {
    setEditorInstance(editor);
  };

  // Value to be provided by the context
  const value = {
    editor: editorInstance,
    setEditor
  };

  return (
    <EditorContext.Provider value={value}>
      {children}
    </EditorContext.Provider>
  );
}

// Custom hook to use the editor context
export function useEditor() {
  const context = useContext(EditorContext);
  if (!context) {
    throw new Error('useEditor must be used within an EditorProvider');
  }
  return context;
}